export type CFXRunTemplateActionType = 'cfxrun_template_added';

export const CFXRUN_TEMPLATE_ADDED: CFXRunTemplateActionType = 'cfxrun_template_added';
